export default __webpack_public_path__ + "static/media/register.39a19e24.svg";